/**
 * Utility functions for working with Payload CMS API responses
 */

import type {PaginatedDocs} from 'payload'

import type {Populated} from '~/types/populated'

/**
 * Extracts the docs array from a Payload paginated response.
 * Returns docs cast as Populated<T> since all composables use depth >= 1.
 */
export function extractDocs<T>(response: PaginatedDocs<T>): Populated<T>[] {
  return (response?.docs ?? []) as Populated<T>[]
}
